exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".relative[data-v-7e4125f1] {\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-position-x: center;\n  background-position-y: top;\n  background-image: url(\"/images/cover.png\");\n  height: 480px;\n}\n@media (min-width: 1024px) {\n.relative[data-v-7e4125f1] {\n    height: 620px;\n}\n}\n.overlay[data-v-7e4125f1] {\n  background: linear-gradient(360deg, rgba(0, 0, 0, 0.7490196078), rgba(202, 174, 174, 0.3215686275));\n}", ""]);

// exports
